export default __webpack_public_path__ + "static/media/asw.a130824f.jpg";